import Vue from 'vue';
import VueI18n from 'vue-i18n';
import english from './en.json';

import ruLocaleApp from './ru/app';
import ruLolaceStores from './ru/stores';
import ruLocaleStudios from './ru/studios';
import ruLocaleServices from './ru/services';
import ruLocalesDialogs from './ru/dialogs';
import ruLocalesUsers from './ru/user';
import ruLocalesClients from './ru/clients';
import ruLocalesCertificate from './ru/certificate';
import ruLocalesLoyalty from './ru/loyalty'
import ruLocalesPayments from './ru/payments'
import ruLocalesCalendar from './ru/calendar'

Vue.use(VueI18n);

const russian = {
        ...ruLocaleApp,
        ...ruLolaceStores,
        ...ruLocaleStudios,
        ...ruLocaleServices,
        ...ruLocalesDialogs,
        ...ruLocalesUsers,
        ...ruLocalesClients,
        ...ruLocalesCertificate,
        ...ruLocalesLoyalty,
        ...ruLocalesPayments,
        ...ruLocalesCalendar
};
function translatedTree(source: any): any {
    return Object.fromEntries(Object.entries(source).map(([key, value]) => [key,
        typeof value === 'object' ? translatedTree(value) : (english as Record<string, string>)[String(value)] || value]));
}
const selected = new URLSearchParams(window.location.search).get('lang');
const saved = localStorage.getItem('pult-language');
const locale = selected === 'en' || selected === 'ru' ? selected : (saved === 'en' ? 'en' : 'ru');
localStorage.setItem('pult-language', locale);
if (selected === 'en' || selected === 'ru') {
    const url = new URL(window.location.href);
    url.searchParams.delete('lang');
    window.history.replaceState(null, '', url.toString());
}
document.documentElement.lang = locale;
document.title = locale === 'en' ? 'Pult — salon and multi-location management' : 'Пульт — управление салонами и сетями';
const messages = {
    ru: {...Object.fromEntries(Object.keys(english).map(key => [key, key])), ...russian},
    en: {...english, ...translatedTree(russian)},
};
const i18n = new VueI18n({ locale, fallbackLocale: 'ru', messages });
export function i18nText(text: string, values?: Record<string, any>): string { return String(i18n.t(text, values)); }
export default i18n;
